import { DocumentVerificationTypes } from '@domain/types';

const WHITELIST: string[] = [
  DocumentVerificationTypes.integration_missing,
  DocumentVerificationTypes.ai_not_available,
  DocumentVerificationTypes.enrichment_failed,
  DocumentVerificationTypes.invalid_patient_name,
  DocumentVerificationTypes.attachment_with_more_than_40_pages,
  DocumentVerificationTypes.recipients_other_than_high,
  DocumentVerificationTypes.recipient_certainly_not,
];

// Structural, not DocumentVerificationV2 (v1) specifically: only `.key` is ever read, and v2's
// VerificationV2.key is a plain `string` — both stay assignable without a cast.
export function isDocumentVerification(verification: { key: string }) {
  return WHITELIST.includes(verification.key);
}
